<script setup>
import WorkflowAutomationsTab from "@/components/workflow-automations/WorkflowAutomationsTab.vue";
import { onMounted, ref } from "vue";
import "vue3-toastify/dist/index.css";

const hasViewWorkflowAutomationsPermission = ref(true)

onMounted(() => {
  const userData = JSON.parse(localStorage.getItem('userData'));
  const userPermissionsByRoles = userData.permissions_by_roles;
  const viewWorkflowAutomationsPermission = Object.values(
    userPermissionsByRoles
  ).some((permissions) => permissions.includes("View Workflow Automations"));
  if (viewWorkflowAutomationsPermission) {
    hasViewWorkflowAutomationsPermission.value = true 
  }
});

definePage({ meta: { requiresAuth: true } });
</script>

<template>
  <div>
    <VCard title="" class="">
      <VCardText class="p-0" style="padding: 0 !important">
        <div v-if="hasViewWorkflowAutomationsPermission" >
          <WorkflowAutomationsTab />
        </div>
      </VCardText>
    </VCard>
  </div>
</template>
